import { FlagsPermissionHandover } from "@/feature-flags/flags-permission-handover";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");

const HandoverList = () =>
  import(
    /* webpackChunkName: "Handover" */ "@/app/ui/views/incoming-process/handover/index.vue"
  );

const HandoverScan = () =>
  import(
    /* webpackChunkName: "Handover" */ "@/app/ui/views/incoming-process/handover-v2/update/index.vue"
  );

const DetailHandover = () =>
  import(
    /* webpackChunkName: "Handover" */ "@/app/ui/views/incoming-process/handover/component/detail.vue"
  );

export default [
  {
    path: "/handover-v2",
    component: Layout,
    name: "handover-v2",
    meta: {
      icon: "handover",
      title: "Handover",
      name: "Handover",
      children: false,
      permission: FlagsPermissionHandover.handover_enable,
      noPaddingWithBreadcrumbV2: true,
      newLayout: true,
    },
    children: [
      {
        path: "/handover-v2",
        name: "handover-v2",
        component: HandoverList,
        meta: {
          header: true,
          noPaddingWithBreadcrumbV2: true,
          newLayout: true,
        }
      }
    ]
  },
  //scan
  {
    path: "/handover-v2",
    component: Layout,
    name: "update-handover-v2",
    meta: {
      hidden: true,
      parent: "Handover",
      noPaddingWithBreadcrumbV2: true,
      newLayout: true,
      permission: FlagsPermissionHandover.handover_scan_first_revamp
    },
    children: [
      {
        path: "update",
        name: "update-handover-v2",
        component: HandoverScan,
        meta: {
          header: true,
          title: "HANDOVER | Scan Handover",
          name: "Scan Handover",
          before: "/handover-v2",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      }
    ]
  },
  //detail
  {
    path: "/handover-v2",
    component: Layout,
    name: "handover-detail-v2",
    meta: {
      hidden: true,
      parent: "Handover",
      permission: FlagsPermissionHandover.handover_detail_view
    },
    children: [
      {
        path: ":id",
        name: "detail-handover-v2",
        component: DetailHandover,
        meta: {
          header: true,
          title: "Handover | Detail",
          name: "Detail Handover",
          before: "/handover-v2"
        }
      }
    ]
  }
];
